import { Box, Typography } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import {
    Button,Grid,TextField,
   Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, TextareaAutosize, IconButton, useMediaQuery,
} from '@mui/material';
import CommentIcon from '@mui/icons-material/Comment';
import { useTheme } from "@mui/material/styles";
import ForumOutlinedIcon from "@mui/icons-material/ForumOutlined";
import CollapseSection from "../../../components/ui/CollapseSection";

const DisplayComments = (params) => {
    const [displayComments, setDisplayComments] = useState("");
    const [userComments, setUserComments] = useState("");
    const [open, setOpen] = useState(false);
    const desiredcolor =
        params?.comments?.length > 0 &&
            params?.comments != "Default Customer quota record"
            ? "blue"
            : "black";

    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down("md"));

    const handleClose = () => {
        setOpen(false);
    };

    return (
        <>
            <IconButton
                onClick={() => setOpen(true)}
                title={params.comments}
            >
                {params?.comments ? (
                    <ForumOutlinedIcon title={params.comments} sx={{ color:"#007DC3" }}/>
                ) : (
                    <ForumOutlinedIcon />
                )}
            </IconButton>

            <Dialog
                disableEnforceFocus
                fullScreen={fullScreen}
                open={open}
                onClose={handleClose}
                aria-labelledby="responsive-dialog-title"
            >
                <DialogTitle id="responsive-dialog-title">Comments</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        <TextareaAutosize
                            onChange={(event) => setUserComments(event.target.value)}
                            aria-label="minimum height"
                            minRows={5}
                            readOnly
                            placeholder=""
                            style={{ width: 500, fontSize: 18 }}
                            defaultValue={params.comments}
                        />
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button
                        variant="outlined"
                        onClick={handleClose}
                        size="small"
                        style={{
                            background: "#286aa6",
                            color: "white",
                            borderRadius: "4px",
                        }}
                    >
                        Cancel
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};

function getColumns(periodDepletionModel) {
    if(periodDepletionModel?.toLowerCase() === "none") {
    const columns  = [
         { field: "customerName", headerName: "Customer / CG", flex:1 },
         { field: "customerNumber", headerName: "Customer Number", flex:1 },
         { field: "skuName", headerName: "SKU / PG", flex:1 },
         { field: "skuNumb", headerName: "SKU Number", flex:1 },
         { field: "initialQuota", headerName: "Initial Quota", flex:1,
            valueFormatter: (params) => {
                const formattedValue = params.value?.toLocaleString();
                return formattedValue;
            }
         },
         { field: "safetyMargin", headerName: "Safety Margin", flex:1,
            valueFormatter: (params) => {
                const formattedValue = params.value?.toLocaleString();
                return formattedValue;
            }
         },
         { field: "adjustment", headerName: "Adjustment", flex:1,
            valueFormatter: (params) => {
                const formattedValue = params.value?.toLocaleString();
                return formattedValue;
            } 
         },
         { field: "totalQuota", headerName: "Total Quota", flex:1,
            valueFormatter: (params) => {
                const formattedValue = params.value?.toLocaleString();
                return formattedValue;
            } 
         },
         {
             field: "customerQuotaComments",
             headerName: "Customer Quota Comments",
             flex:1,
             renderCell: (cellValues) => {
             return <DisplayComments readonly comments={cellValues.value} />;
             },
         },
     ];
     return columns;
    }else if(periodDepletionModel?.toLowerCase() === "biweekly") {
        const columns  = [
             { field: "customerName", headerName: "Customer / CG", flex:1 },
             { field: "customerNumber", headerName: "Customer Number", flex:1 },
             { field: "skuName", headerName: "SKU / PG", flex:1 },
             { field: "skuNumb", headerName: "SKU Number", flex:1 },
             { field: "initialQuota", headerName: "Initial Quota", flex:1,
                valueFormatter: (params) => {
                    const formattedValue = params.value?.toLocaleString();
                    return formattedValue;
                } 
             },
             { field: "safetyMargin", headerName: "Safety Margin", flex:1,
                valueFormatter: (params) => {
                    const formattedValue = params.value?.toLocaleString();
                    return formattedValue;
                } 
             },
             { field: "adjustment", headerName: "Adjustment", flex:1,
                valueFormatter: (params) => {
                    const formattedValue = params.value?.toLocaleString();
                    return formattedValue;
                } 
             },
             { field: "totalQuota", headerName: "Total Quota", flex:1,
                valueFormatter: (params) => {
                    const formattedValue = params.value?.toLocaleString();
                    return formattedValue;
                } 
             },
             { field: "weekly1", headerName: "First Half", flex:1,
                valueFormatter: (params) => {
                    const formattedValue = params.value?.toLocaleString();
                    return formattedValue;
                } 
             },
             { field: "weekly2", headerName: "Second Half", flex:1,
                valueFormatter: (params) => {
                    const formattedValue = params.value?.toLocaleString();
                    return formattedValue;
                } 
             },
             {
                 field: "customerQuotaComments",
                 headerName: "Customer Quota Comments",
                 flex:1,
                 renderCell: (cellValues) => {
                 return <DisplayComments readonly comments={cellValues.value} />;
                 },
             },
         ];
         return columns;
    }else{
        const columns  = [
             { field: "customerName", headerName: "Customer / CG", flex:1 },
             { field: "customerNumber", headerName: "Customer Number", flex:1 },
             { field: "skuName", headerName: "SKU / PG", flex:1 },
             { field: "skuNumb", headerName: "SKU Number", flex:1 },
             { field: "initialQuota", headerName: "Initial Quota", flex:1,
                valueFormatter: (params) => {
                    const formattedValue = params.value?.toLocaleString();
                    return formattedValue;
                } 
             },
             { field: "safetyMargin", headerName: "Safety Margin", flex:1,
                valueFormatter: (params) => {
                    const formattedValue = params.value?.toLocaleString();
                    return formattedValue;
                } 
             },
             { field: "adjustment", headerName: "Adjustment", flex:1,
                valueFormatter: (params) => {
                    const formattedValue = params.value?.toLocaleString();
                    return formattedValue;
                } 
             },
             { field: "totalQuota", headerName: "Total Quota", flex:1,
                valueFormatter: (params) => {
                    const formattedValue = params.value?.toLocaleString();
                    return formattedValue;
                } 
             },
             { field: "weekly1", headerName: "Week 1", flex:1,
                valueFormatter: (params) => {
                    const formattedValue = params.value?.toLocaleString();
                    return formattedValue;
                } 
             },
             { field: "weekly2", headerName: "Week 2", flex:1,
                valueFormatter: (params) => {
                    const formattedValue = params.value?.toLocaleString();
                    return formattedValue;
                } 
             },
             { field: "weekly3", headerName: "Week 3", flex:1,
                valueFormatter: (params) => {
                    const formattedValue = params.value?.toLocaleString();
                    return formattedValue;
                } 
             },
             { field: "weekly4", headerName: "Week 4", flex:1,
                valueFormatter: (params) => {
                    const formattedValue = params.value?.toLocaleString();
                    return formattedValue;
                } 
             },
             { field: "weekly5", headerName: "Week 5", flex:1,
                valueFormatter: (params) => {
                    const formattedValue = params.value?.toLocaleString();
                    return formattedValue;
                } 
             },
             {
                 field: "customerQuotaComments",
                 headerName: "Customer Quota Comments",
                 flex:1,
                 renderCell: (cellValues) => {
                 return <DisplayComments readonly comments={cellValues.value} />;
                 },
             },
         ];
         return columns;
    }
}
export default function QuotaDetailsTable() {
	const state = useSelector((store) => store.quota);
	const { quotaDetailsTable, quotaCustomerBreakdown } = state;
    const { rows } = quotaDetailsTable;
    const columns = getColumns(quotaCustomerBreakdown.periodDepletionModel);

    const [searchCustomer, setSearchCustomer] = useState("");
    const [searchProduct, setSearchProduct] = useState("");
    const [filteredRows, setFilteredRows] = useState(rows);
    const [paginationModel, setPaginationModel] = useState({
        pageSize: 20,
        page: 0
    });

    const handleSearchCustomer = (e) => {
        const value = e.target.value;
        setSearchCustomer(value);
    };

    const handleSearchProduct = (e) => {
        const value = e.target.value;
        setSearchProduct(value);
    };
    useEffect(() => {
        handleOnCustomerProductChange(searchCustomer, searchProduct);
    }, [searchCustomer, searchProduct, rows]);

    useEffect(() => {
        setSearchProduct("");
        setSearchCustomer("");
    },[rows]);

    const handleOnCustomerProductChange = (selectCustomer, selectProduct) => {
        setFilteredRows((prevVal) => {
            if(searchProduct === undefined)setSearchProduct("");
            if(searchCustomer === undefined)setSearchCustomer("");
            let val = rows?.filter((item) => {
            let retVal = false;
            if (
                item.customerName !== undefined &&
                item.customerNumber !== undefined &&
                item.skuName !== undefined &&
                item.skuNumb !== undefined
            ) {
                retVal =
                    (item.customerName
                    .toLowerCase()
                    .includes(searchCustomer.toLowerCase()) ||
                    item.customerNumber
                        .toLowerCase()
                        .includes(searchCustomer.toLowerCase())) &&
                    (item.skuName
                    .toLowerCase()
                    .includes(searchProduct?.toLowerCase()) ||
                    item.skuNumb
                        .toLowerCase()
                        .includes(searchProduct?.toLowerCase()));
            } else {
                return retVal;
            }
            return retVal;
            });
            return val;
        });
    };

	return (
		<Box sx={{ mt: 5, maxWidth: "100%" }}>
			{/* <Typography className="compHeading" variant="subtitle1">Quota Details</Typography> */}
            <CollapseSection title="Quota Details">

        <Grid
          container
          columns={12}
          alignItems="center"
          spacing={2}
          pb={1}
          pt={3}
        >
            <Grid item xs={3}>
              <TextField
                variant="outlined"
                label="Search Customer"
                value={searchCustomer}
                onChange={handleSearchCustomer}
                onKeyDown={(e) => {
                  if (e.key !== "Escape") {
                    // Prevents autoselecting item while typing (default Select behaviour)
                    e.stopPropagation();
                  }
                }}
                fullWidth
                size="small"
              ></TextField>
            </Grid>

            <Grid item xs={3}>
              <TextField
                variant="outlined"
                label="Search Product"
                value={searchProduct}
                onKeyDown={(e) => {
                  if (e.key !== "Escape") {
                    // Prevents autoselecting item while typing (default Select behaviour)
                    e.stopPropagation();
                  }
                }}
                onChange={handleSearchProduct}
                fullWidth
                size="small"
              ></TextField>
            </Grid>
          </Grid>
			<DataGrid style={{ maxHeight: 'calc(100vh - 130px)'}}
            rows={filteredRows} 
            columns={columns} 
            disableColumnMenu
            paginationModel={paginationModel}
            onPaginationModelChange={setPaginationModel}
            pageSizeOptions={[ 20, 50, 100]}
            headerHeight={40} 
         />
         </CollapseSection>
		</Box>
	);
}
